import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'

export interface GetServicesArgs {
  locale: string
}

export type ServiceCategoryDto = {
  id: number
  attributes: {
    short_description: string
    slug: string
    name: string
    image: MediaObject
  }
}

export type ServicesDto = {
  data: {
    id: number
    attributes: {
      services_title: string
      services_more_button_text: string
      service_categories: {
        data: ServiceCategoryDto[]
      }
    }
  }
  meta: Record<string, unknown>
}

export const getServices = async (
  client: AxiosInstance,
  { locale }: GetServicesArgs,
): Promise<ServicesDto['data']['attributes']> => {
  const path = `/home-page`
  const params = {
    locale,
    fields: ['services_title', 'services_more_button_text'],
    populate: {
      fields: ['service_categories'],
      service_categories: {
        fields: ['id', 'short_description', 'slug', 'name'],
        populate: {
          image: {
            populate: '*',
          },
        },
      },
    },
  }
  return (await client.get<ServicesDto>(path, { params })).data.data.attributes
}
